<div *ngIf="selectedIssuers.length > 0; else noData">
  <p-table
    [value]="selectedIssuers"
    [paginator]="true"
    [rows]="5"
    [tableStyle]="{ 'min-width': '50rem' }"
    selectionMode="single"
    [(selection)]="selectedDialogRow"
    dataKey="asReportedIssuerId"
    (onRowSelect)="onDialogRowSelect($event)"
    (onRowUnselect)="onDialogRowUnselect($event)"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-end items-center w-full gap-4">
        <!-- First Issuer Search -->
        <div class="relative w-60">
          <input
            type="text"
            [(ngModel)]="searchIssuer"
            (keydown.enter)="onSearchEnter()"
            placeholder="Search from asReportedIssuer..."
            class="border border-gray-300 rounded px-3 py-1 text-sm w-full"
            (focus)="showDropdown = filteredIssuers.length > 0"
            (keydown)="preventSpaceKey($event)"
            (paste)="onPaste($event, 'searchIssuer')"
          />
          <div
            *ngIf="showDropdown && filteredIssuers.length > 0"
            class="absolute z-50 mt-1 w-full border border-gray-300 bg-white shadow-md max-h-60 overflow-auto rounded"
          >
            <div
              *ngFor="let issuer of filteredIssuers"
              class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              (click)="onIssuerSelect(issuer)"
            >
              {{
                (issuer.issuerId !== null ? issuer.issuerId + "  :  " : "") +
                  issuer.asReportedIssuerName
              }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>A R C. Id</th>
        <th>Id</th>
        <th>Issuer Name</th>
        <th>CIK</th>
        <th>EIN</th>
        <th>SIC</th>
        <th>File No</th>
        <th>Year End</th>
        <th>STATE OF INCORPORATION</th>
      </tr>
    </ng-template>
    <ng-template #body let-product>
      <tr [pSelectableRow]="product">
        <td>{{ product.asReportedIssuerId || "N/A" }}</td>
        <td>{{ product.issuerId }}</td>
        <td>{{ product.asReportedIssuerName || "N/A" }}</td>
        <td
          [ngClass]="{
            'text-yellow-500': duplicateCiks.has(product.asReportedCik)
          }"
        >
          {{ product.asReportedCik || "N/A" }}
        </td>

        <td>{{ product.asReportedEin || "N/A" }}</td>
        <td>{{ product.asReportedSic || "N/A" }}</td>
        <td>{{ product.asReportedFileNumber || "N/A" }}</td>
        <td>{{ product.asReportedFiscalYearEnd || "N/A" }}</td>
        <td>{{ product.asReportedStateOfIncorporation || "N/A" }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
<div
  class="grid gap-6 my-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="companyName"
      [(ngModel)]="formData.asReportedIssuerName"
      [ngClass]="{
        'border-red-500': validationErrors.asReportedIssuerName
      }"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedIssuerName')"
      (input)="validationErrors.asReportedIssuerName = ''"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      name
    </label>
    <small
      *ngIf="validationErrors.asReportedIssuerName"
      class="text-red-500 text-xs mt-1 block"
    >
      {{ validationErrors.asReportedIssuerName }}
    </small>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="cik"
      [(ngModel)]="formData.asReportedCik"
      [ngClass]="{
        'border-red-500': validationErrors.asReportedCik
      }"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedCik')"
      (input)="validationErrors.asReportedCik = ''"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Cik
    </label>
    <small
      *ngIf="validationErrors.asReportedCik"
      class="text-red-500 text-xs mt-1 block"
    >
      {{ validationErrors.asReportedCik }}
    </small>
  </div>

  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="irs"
      [(ngModel)]="formData.asReportedEin"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedEin')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >Ein</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="irs"
      [(ngModel)]="formData.asReportedStateOfIncorporation"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedStateOfIncorporation')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >State of Incorporation</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="fileNo"
      [(ngModel)]="formData.asReportedFileNumber"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedFileNumber')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >File no</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="yearEnd"
      [(ngModel)]="formData.asReportedFiscalYearEnd"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedFiscalYearEnd')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >Year end</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="yearEnd"
      [(ngModel)]="formData.asReportedSic"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedSic')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >Sic</label
    >
  </div>
  <div
    *ngIf="selectedDialogRow && formData.issuerId"
    class="flex items-center mt-2"
  >
    <input
      type="checkbox"
      class="mr-1"
      [(ngModel)]="formData.mapWithCompanyId"
    />
    <label class="whitespace-nowrap">Map With Company Id</label>
  </div>
</div>
<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-[#1f273b] text-white hover:bg-[#1f273b] text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onSubmit()"
  >
    Submit
  </button>
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
<!-- <p-toast></p-toast> -->
